import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [status, setStatus] = useState({ ok: null, msg: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ ok: null, msg: "" });
    try {
      await api.post("/contact", form);
      setStatus({ ok: true, msg: "Message envoyé. Nous revenons vers vous très vite." });
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      setStatus({ ok: false, msg: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#0a0a0a] text-white pt-32 pb-24" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="eyebrow mb-4">/ Contact</div>
          <h1 className="font-display font-bold uppercase tracking-tighter text-5xl md:text-6xl leading-[0.92]">
            Parlons<br /><span className="text-[#ffd600]">de votre chantier.</span>
          </h1>
          <p className="text-neutral-400 mt-6 leading-relaxed">
            Une question technique, un planning à caler, une visite de site ? Notre bureau d’études vous répond rapidement.
          </p>

          <div className="mt-10 space-y-5">
            <div className="brut-card !p-5">
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#ffd600]" />
                <div className="font-display uppercase tracking-wider">Téléphone</div>
              </div>
              <div className="text-neutral-300 mt-2">
                <a href="tel:+33651026078" className="hover:text-[#ffd600] block">06 51 02 60 78</a>
                <a href="tel:+33766001001" className="hover:text-[#ffd600] block">07 66 00 10 01</a>
              </div>
            </div>
            <div className="brut-card !p-5">
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#ffd600]" />
                <div className="font-display uppercase tracking-wider">Email</div>
              </div>
              <a href="mailto:contact@dcrbati.fr" className="text-neutral-300 mt-2 inline-block hover:text-[#ffd600]">contact@dcrbati.fr</a>
            </div>
            <div className="brut-card !p-5">
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-location-dot text-[#ffd600]" />
                <div className="font-display uppercase tracking-wider">Siège</div>
              </div>
              <div className="text-neutral-300 mt-2">470 Clos de la Courtine<br />93160 Noisy-le-Grand, France</div>
            </div>
            <div className="brut-card !p-5">
              <div className="flex items-center gap-3">
                <i className="fa-solid fa-map text-[#ffd600]" />
                <div className="font-display uppercase tracking-wider">Zone d&apos;intervention</div>
              </div>
              <div className="text-neutral-300 mt-2">Toute l&apos;Île-de-France</div>
              <div className="font-mono-tech text-[10px] uppercase tracking-widest text-neutral-500 mt-2">
                75 · 77 · 78 · 91 · 92 · 93 · 94 · 95
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="md:col-span-7 brut-card !p-8 md:!p-10" data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label className="label-field">Nom complet *</label>
              <input required value={form.name} onChange={set("name")} className="input-field" data-testid="contact-name" />
            </div>
            <div>
              <label className="label-field">Email *</label>
              <input required type="email" value={form.email} onChange={set("email")} className="input-field" data-testid="contact-email" />
            </div>
            <div>
              <label className="label-field">Téléphone</label>
              <input value={form.phone} onChange={set("phone")} className="input-field" data-testid="contact-phone" />
            </div>
            <div>
              <label className="label-field">Sujet</label>
              <input value={form.subject} onChange={set("subject")} className="input-field" data-testid="contact-subject" />
            </div>
          </div>
          <div className="mt-5">
            <label className="label-field">Message *</label>
            <textarea required rows={6} value={form.message} onChange={set("message")} className="input-field resize-none" data-testid="contact-message" />
          </div>

          {status.msg && (
            <div
              className={`mt-5 p-4 border ${status.ok ? "border-emerald-500/40 text-emerald-300 bg-emerald-500/10" : "border-red-500/40 text-red-300 bg-red-500/10"} font-mono-tech text-sm`}
              data-testid="contact-status"
            >
              {status.msg}
            </div>
          )}

          <div className="mt-7 flex items-center justify-between">
            <div className="font-mono-tech text-xs text-neutral-500 uppercase tracking-widest">Réponse sous 24h ouvrées</div>
            <button type="submit" disabled={loading} className="btn-primary" data-testid="contact-submit">
              {loading ? "Envoi…" : "Envoyer le message"} <i className="fa-solid fa-paper-plane" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
